import StuMainTitle from "./StuMainTitle"

StuMainTitle.install = Vue => {
    vue.component(StuMainTitle.name,StuMainTitle)
}


export default StuMainTitle